<template>
  <div>
    <v-toolbar v-if="$route.name !== 'continuous_age_estimation_iframe' && $route.name !== 'ageavatar' && $route.name !== 'digital_guardian_faq' && $route.name !== 'aiframe'" color="grey lighten-4" lighten app absolute clipped-left>
      <!-- <v-toolbar-side-icon @click="setDrawer(!drawer)"></v-toolbar-side-icon> -->

      <router-link  to="/">
        <v-btn depressed>
          <v-icon>home</v-icon>
        </v-btn>
      </router-link>
      <span class="title ml-3 mr-5">
        Privately&nbsp;
        <span class="font-weight-light">Showroom</span>
      </span>

      <template v-if="$route.name === 'video'">
        <v-btn flat color="#719bee" @click="startTwitchTour"> <v-icon>lightbulb_outline</v-icon>View Tour </v-btn>
      </template>

      <template v-if="$route.name === 'labeling'">
        <labeling-progress></labeling-progress>

        <v-toolbar-items v-if="user">
          <v-btn flat @click="setTaskDialog(true)"> <v-icon>settings</v-icon>Adjust Settings </v-btn>
          <v-tooltip top>
            <v-btn
              slot="activator"
              @click="removeAllTasks()"
              fab
              small
              depressed
              color="grey lighten-2"
              style="margin-top: 30%"
            >
              <v-icon color="grey">close</v-icon>
            </v-btn>
            <span>Ignore all items.</span>
          </v-tooltip>
        </v-toolbar-items>
      </template>

      <template v-if="$route.name === 'dataDebugger' || $route.name === 'interact'">
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <!-- v-if="user" -->
          <v-btn flat @click="setTaskDialog(true)"> <v-icon>settings</v-icon>Adjust Settings </v-btn>
        </v-toolbar-items>
      </template>

      <v-spacer v-else></v-spacer>
      <template v-if="false">
        <v-toolbar-side-icon v-if="!user" to="sign-in">
          <v-icon>account_circle</v-icon>
        </v-toolbar-side-icon>
        <v-tooltip bottom v-if="user">
          <v-toolbar-side-icon @click="signOut" slot="activator">
            <v-icon>exit_to_app</v-icon>
          </v-toolbar-side-icon>
          <span>Sign out {{ user.email }}</span>
        </v-tooltip>
      </template>

      <a href="https://privately.eu" target="blank">
        <v-btn fab icon>
          <v-avatar size="45">
            <img :src="logoImg" alt="logo" />
          </v-avatar>
        </v-btn>
      </a>
    </v-toolbar>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Firebase from "firebase/app";
import "firebase/auth";

export default {
  data() {
    return {
      loader: null,
      logoImg: require("@/assets/logo.png"),
    };
  },
  components: {},
  computed: {
    ...mapGetters("authentication", {
      user: "user",
    }),
    ...mapGetters("common", {
      drawer: "drawer",
    }),
  },
  methods: {
    ...mapActions("common", {
      setDrawer: "setDrawer",
    }),
    ...mapActions("labeling", {
      removeAllTasks: "removeAllTasks",
      setTaskDialog: "setTaskDialog",
    }),
    ...mapActions("authentication", {
      setUser: "setUser",
    }),
    startTwitchTour(time) {
      this.$tours["twitchTour"].start();
    },
    signOut: function () {
      Firebase.auth()
        .signOut()
        .then(() => {
          this.setUser();
          this.$router.push({ name: "signIn" });
        });
    },
  },
};
</script>

<style>
</style>
